import { StandardTextFieldProps, SxProps, Theme, Typography, Stack, TextField as MuiTextField, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface TextFieldProps extends StandardTextFieldProps {
  name?: string;
  label?: string;
  defaultValue?: string;
  sx?: SxProps<Theme>;
  maxLength?: number;
}

const TextField = ({ name, label, defaultValue, sx = [], maxLength, ...props }: TextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name ? name : ''}
      defaultValue=""
      control={control}
      render={({
        field,
        field: { onChange, value },
        fieldState
      }) => (
        <Stack
          direction="column"
          spacing={0.5}
          width="100%">
          {label &&
            <Typography variant="secondaryFont" >
              {label}
            </Typography>
          }
          <MuiTextField
            sx={[
              {
                minWidth: '225px',
                backgroundColor: 'white',
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderImage: 'linear-gradient(#c2171d, #ff9e2d) 30%',
                    borderWidth: '2px'
                  }
                }
              },
              ...(Array.isArray(sx) ? sx : [sx])
            ]}
            {...field}
            value={value}
            {...props}
            onChange={onChange}
            variant="outlined"
          />
          <Typography
            variant="errorFont">
            {fieldState.error?.message}
          </Typography>
          {(!fieldState.error?.message && props.multiline) && 
            <FormHelperText 
            sx={{ 
              textAlign: 'right'
            }}>
              {value.length} / {maxLength}
            </FormHelperText>
          }
        </Stack>
      )}
    />
  );
}

export default TextField;